import React from "react";
import Marquee from "react-fast-marquee";

const ITEMS = [
  "Your Trusted Ride, Every Time",
  "Haymarket, VA",
  "Airport Transfers",
  "Medical Appointments",
  "Personal Rides",
  "Family Operated",
];

export const Ribbon = () => {
  return (
    <div data-testid="editorial-ribbon" className="relative border-y border-white/10 bg-[#0a0a0a] py-6 overflow-hidden">
      <Marquee speed={40} gradient gradientColor="#0a0a0a" gradientWidth={120}>
        {ITEMS.concat(ITEMS).map((item, i) => (
          <span key={i} className="flex items-center">
            <span className="font-serif-display italic text-2xl md:text-4xl text-neutral-200 mx-8">{item}</span>
            <span className="text-[#D4AF37] text-2xl md:text-3xl">✦</span>
          </span>
        ))}
      </Marquee>
    </div>
  );
};
